import Cache from './cache'
import Cookie from './cookie'
import Global from './global'
import { Api } from './api'

export default {

    authorize_url: Global.SSO_END_POINT + 'connect/authorize',
    addclaims_authorize_url: Global.SSO_END_POINT + '/accountafterauth/claimsadd',
    endsession_url: Global.SSO_END_POINT + 'connect/endsession',
    redirect_uri: Global.SSO_REDIRECT_LOGIN_URL,
    post_logout_redirect_uri: Global.SSO_REDIRECT_LOGOUT_URL,

    client_id: Global.SSO_CLIENT_ID,
    response_type: Global.SSO_RESPONSE_TYPE,
    scope: Global.SSO_SCOPE,

    menu_key: 'SHOP___FXX_JB_01',
    permissoes_key: 'SHOP___FXX_JB_02',
    loadfinished_key: 'SHOP___FXX_JB_04',
    lastlocation_key: 'SHOP___AEF_03_5O',
    modalInatividade: 'SHOP___FXX_JB_05',
    encerraSessao: 'SHOP___FXX_JB_06',
    ehCnaStore_key: 'SHOP___FXX_JB_07',

    getToken() {
        return Cache.get(Global.ID_TOKEN);
    },

    getAccessToken() {
        return Cache.get(Global.ACCESS_TOKEN);
    },

    getState() {
        return Cache.get(Global.ID_STATE);
    },

    logged() {
        return Cache.get(Global.ID_TOKEN) && Cache.get(this.loadfinished_key) == "finished";
    },

    login(saveActualPage) {

        if (saveActualPage)
            Cache.add(this.lastlocation_key, window.location.pathname);

        Cache.add(Global.ID_STATE, Date.now());

        var url = this.authorize_url + "?" +
            "client_id=" + encodeURIComponent(this.client_id) + "&" +
            "redirect_uri=" + encodeURIComponent(this.redirect_uri) + "&" +
            "response_type=" + encodeURIComponent(this.response_type) + "&" +
            "scope=" + encodeURIComponent(this.scope) + "&" +
            "state=" + encodeURIComponent(this.getState()) + "&" +
            "nonce=xyz&prompt=login";

        window.location = url;
    },

    getCurrentUser(callback, onError) {
        var api = new Api("currentuser");
        api.hasDefaultFilters = false;
        api.get().then(response => {
            var _user = response.data;
            this.updatePessoaCna(_user.pessoacna, callback)
        });
    },

    updatePessoaCna(_id, callback) {
        new Api('pessoacna', Global.END_POINT_ACCOUNT).get({
            id: _id
        }).then(result => {
            Cache.add(Global.USER_INFO, JSON.stringify(result.data));
            setTimeout(() => { callback(result.data, _id) }, 500);
        })
    },

    currentUser() {
        var _user = JSON.parse(Cache.get(Global.USER_INFO));
        return _user;
    },

    logout() {

        var url = this.endsession_url + "?" +
            "id_token_hint=" + this.getToken() + "&" +
            "post_logout_redirect_uri=" + encodeURIComponent(this.post_logout_redirect_uri) + "&" +
            "state=" + encodeURIComponent(this.getState());

        this.reset();

        window.location = url;
    },

    processTokenCallback(callback) {

        if (window.location.href.indexOf("access_token") < 0) {
            callback();
            return;
        }

        this.reset();

        var itens = window.location.hash.split('#');
        var result = itens[1].split('&').reduce(function (result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
        }, {});

        Cache.add(Global.ACCESS_TOKEN, result.access_token, result.expires_in);
        Cache.add(Global.ID_TOKEN, result.id_token, result.expires_in);

        setTimeout(() => {
            callback();
        }, 500);

    },

    claimsAddLoginSso(claim_type, claim_value) {

        Cache.add(Global.ID_STATE, Date.now());

        let url = this.addclaims_authorize_url + "?" +
            "claims_type=" + encodeURIComponent(claim_type) + "&" +
            "claims_value=" + encodeURIComponent(claim_value) + "&" +
            "client_id=" + encodeURIComponent(this.client_id) + "&" +
            "redirect_uri=" + encodeURIComponent(this.redirect_uri) + "&" +
            "response_type=" + encodeURIComponent(this.response_type) + "&" +
            "scope=" + encodeURIComponent(this.scope) + "&" +
            "state=" + encodeURIComponent(this.getState()) + "&" +
            "nonce=xyz";

        Cache.remove(Global.USER_INFO);

        window.location = url;
    },

    reset() {
        Cache.remove(Global.ACCESS_TOKEN);
        Cache.remove(Global.ID_TOKEN);
        Cache.remove(Global.USER_INFO);
        Cache.remove("LOGIN_CNA_STORE");
    },

    getPermissoes() {
        var _fromcache = Cache.get(this.permissoes_key);
        return JSON.parse(_fromcache);
    },

    getMenu() {
        var _fromcache = Cache.get(this.menu_key);
        return JSON.parse(_fromcache);
    },

    canAccess(url) {

        return true;

        if (url == '' ||
            url == '/' ||
            url == '/home')
            return true;

        var permissions = this.getPermissoes();
        var can = false;

        if (url.endsWith("/"))
            url = url.slice(0, -1)

        var rotaSplited = url.split('/');

        for (var key in permissions) {
            var splited = permissions[key].split('/');
            var todosparametrosbatem = false;
            for (var itemrota in rotaSplited) {
                if (splited[itemrota] == "[parametro]" || rotaSplited[itemrota] == splited[itemrota]) {
                    todosparametrosbatem = true;
                }
                else {
                    todosparametrosbatem = false;
                    break;
                }
            }

            if (todosparametrosbatem) {
                can = true;
                break;
            }
        }

        if (!can)
            return false;

        return true;
    }
}
